import type { Publication } from '~/interfaces/publication';
import type { Subscription } from '~/interfaces/subscriptions';

import { useWebThemeContext } from '../Layout/Context/useWebThemeContext';
import Template1 from './Templates/Template1';
import Template2 from './Templates/Template2';
import Template3 from './Templates/Template3';
import Template4 from './Templates/Template4';
import Template5 from './Templates/Template5';
import Template6 from './Templates/Template6';

interface Props {
  publication: Publication;
  isLoggedin?: boolean;
  isAdminLoggedIn?: boolean;
  subscription?: Subscription;
}

const safelyRenderTemplate = (template: string) => {
  if (!template) {
    return 'template-1';
  }

  if (!['template-1', 'template-2', 'template-3', 'template-4', 'template-5', 'template-6'].includes(template)) {
    return 'template-1';
  }

  return template;
};

const Navbar = ({ publication, subscription, isAdminLoggedIn, isLoggedin }: Props) => {
  const { webTheme: theme } = useWebThemeContext();
  const templateVariant = safelyRenderTemplate(theme?.navbar_template);
  const showActions = !isLoggedin && !publication.private;

  const Template: any = {
    'template-1': Template1,
    'template-2': Template2,
    'template-3': Template3,
    'template-4': Template4,
    'template-5': Template5,
    'template-6': Template6,
  }[templateVariant];

  return (
    <Template
      publication={publication}
      isLoggedIn={isLoggedin}
      subscription={subscription}
      isAdminLoggedIn={isAdminLoggedIn}
      showActions={showActions}
      theme={theme}
    />
  );
};

export default Navbar;
